// @ts-nocheck
import React from 'react';
import Select, { components } from 'react-select';

const customStylesForm = {
  container: (provided, state) => ({
    backgroundColor: 'white',
    zIndex: '200',
    cursor: 'pointer',
    // width: '100%',
    // maxWidth: '404px',
  }),
  control: (provided, state) => ({
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-beetween',
    height: '46px',
    margin: '0',
    border: state.menuIsOpen ? null : '2px solid #DDDDE3',
    borderTop: state.menuIsOpen ? '2px solid #FFD600' : null,
    borderRight: state.menuIsOpen ? '2px solid #FFD600' : null,
    borderLeft: state.menuIsOpen ? '2px solid #FFD600' : null,
    borderBottom: state.menuIsOpen ? '2px solid transparent' : null,
    backgroundImage: state.menuIsOpen
      ? 'url("../../assets/icons/top.svg")'
      : 'url("../../assets/icons/up.svg")',
    backgroundPosition: '95% 50%',
    backgroundRepeat: 'no-repeat',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderRadius: state.menuIsOpen ? null : '8px',
    '&:hover': {
      border: state.menuIsOpen ? null : '2px solid #718096',
    },
  }),

  menu: (provided, state) => ({
    border: '2px solid #FFD600',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    borderTop: 'none',
    textAlign: 'left',
    position: 'absolute',
    width: '100%',
    maxWidth: '194px',
    backgroundColor: '#ffffff',
    zIndex: '123123123123',
    overflow: 'auto',
  }),
  indicatorSeparator: (provided, state) => ({}),
  option: (provided, state) => ({
    fontStyle: 'normal',
    fontWeight: state.isSelected ? '700' : 'normal',
    height: '46px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 12px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FFD600',
    },
  }),
  dropdownIndicator: (provided, state) => ({
    marginRight: '8px',
    marginBottom: state.isActive ? '-4px' : '4px',
    transform: state.isActive ? 'rotate(180deg)' : null,
  }),
};

export const customStyles = ({ maxWidth }) => ({
  container: (provided, state) => ({
    boxSizing: 'border-box',
    backgroundColor: 'white',
    position: 'relative',
    cursor: 'pointer',
    width: '100%',
    maxWidth: maxWidth ?? '360px',
    fontFamily: "Gilroy, 'Open Sans', sans-serif",
    color: '#222222',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '1.6em',
  }),
  control: (provided, state) => ({
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-beetween',
    height: '46px',
    margin: '0',
    border: state.menuIsOpen ? null : '2px solid #DDDDE3',
    borderTop: state.menuIsOpen ? '2px solid #FFD600' : null,
    borderRight: state.menuIsOpen ? '2px solid #FFD600' : null,
    borderLeft: state.menuIsOpen ? '2px solid #FFD600' : null,
    backgroundImage: state.menuIsOpen
      ? 'url("../../assets/icons/top.svg")'
      : 'url("../../assets/icons/up.svg")',
    backgroundPosition: '95% 50%',
    backgroundRepeat: 'no-repeat',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderRadius: state.menuIsOpen ? null : '8px',
    '&:hover': {
      border: state.menuIsOpen ? null : '2px solid #718096',
    },
  }),
  singleValue: (provided, state) => ({
    fontWeight: '700',
  }),
  menu: (provided, state) => ({
    border: '2px solid #FFD600',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    borderTop: 'none',
    textAlign: 'left',
    position: 'absolute',
    width: '100%',
    maxWidth: maxWidth ?? '360px',
    backgroundColor: '#ffffff',
    zIndex: '123123123123',
    maxHeight: '276px',
    overflow: 'auto',
  }),
  indicatorSeparator: (provided, state) => ({}),
  option: (provided, state) => ({
    fontStyle: 'normal',
    fontWeight: state.isSelected ? '700' : 'normal',
    height: '46px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 0 0 12px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FFD600',
    },
  }),
  dropdownIndicator: (provided, state) => ({
    marginRight: '15px',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    display: 'flex',
    justifyContent: 'flex-start',
  }),
});

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        width="0"
        height="0"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 0L5 5L10 0H0Z" fill="#222222" />
      </svg>
    </components.DropdownIndicator>
  );
};

export default function InputSelect({
  defaultValue,
  onchangeInput,
  options,
  selectForm = false,
  customSelectStyles = {},
}) {
  return (
    <>
      {selectForm ? (
        <Select
          dropdownIndicator
          styles={customStylesForm}
          defaultValue={defaultValue}
          onChange={onchangeInput}
          options={options}
          //   maxMenuHeight={100}
          isSearchable={false}
          maxMenuHeight={200}
          components={{ DropdownIndicator }}
        />
      ) : (
        <Select
          dropdownIndicator
          isSearchable={false}
          styles={customStyles(customSelectStyles)}
          defaultValue={defaultValue}
          onChange={onchangeInput}
          maxMenuHeight={250}
          options={options}
          components={{ DropdownIndicator }}
        />
      )}
    </>
  );
}

// STYLE KEYS:
// https://stackoverflow.com/questions/55264659/how-do-i-figure-out-which-react-select-style-keys-map-to-which-components
// clearIndicator
// container
// control
// dropdownIndicator
// group
// groupHeading
// indicatorsContainer
// indicatorSeparator
// input
// loadingIndicator
// loadingMessage
// menu
// menuList
// menuPortal
// multiValue
// multiValueLabel
// multiValueRemove
// noOptionsMessage
// option
// placeholder
// singleValue
// valueContainer
